<template>
<transition name="fade">
  <div class="alert-top" v-if="visible">
    <div class="abs">
          <div class="title">{{status}}</div><div class="message">{{message}}</div> <div class="adx-ic_close btn_close" @click="close"></div>
    </div>
  </div>
</transition>
</template>

<script>

export default {
  name: 'adx-topalert',
  components: {

  },
  props: {
    status: {
      required: true
    },
    message:{
      required:true
    },
  },
  data() {
    return {
      visible:false
    }
  },
  computed: {

  },
  watch: {
 
 },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    // this.setFadeOut();
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    fadeout(){
      this.visible = true
      setTimeout(() => (
        this.visible = false
      ), 4000);
    },
    close(){
      this.visible = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
